module.exports = __webpack_public_path__ + "vue_assets/img/caeora.422e77bb.png";